import React, { useState } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  Box,
  Divider,
  Flex,
  Text,
  useColorModeValue,
  useTheme,
} from "@chakra-ui/react";
import { FaChevronDown, FaChevronUp, FaInfo } from "react-icons/fa";

const CustomAccordion = ({ items, handleCardClick }) => {
  const [activeIndex, setActiveIndex] = useState(0); // Set to 0 to default to expanded
  const [hoverIndex, setHoverIndex] = useState(null);
  const theme = useTheme();

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const handleMouseEnter = (index) => {
    setHoverIndex(index);
  };

  const handleMouseLeave = () => {
    setHoverIndex(null);
  };

  const bgColor = useColorModeValue("white", "#1a202c");
  const headerBgColor = useColorModeValue("white", "#2d3748");
  const headerHoverBgColor = useColorModeValue(
    theme.colors.gray[200],
    "#4a5568"
  );
  const dividerColor = useColorModeValue("#dcdcdc", "#4a5568");
  const itemCountBgColor = useColorModeValue(theme.colors.gray[200], "#1a202c");
  const textColor = useColorModeValue("black", "white");

  const styles = {
    accordion: {
      backgroundColor: bgColor,
      borderRadius: "4px",
      overflow: "hidden",
      width: "300px",
      minWidth: "300px",
      color: textColor,
      fontFamily: "Arial, sans-serif",
      height: "fit-content",
    },
    accordionItem: {
      borderBottom: `1px solid ${dividerColor}`, // Border color between items
    },
    accordionHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 15px",
      cursor: "pointer",
      backgroundColor: headerBgColor, // Header background color
      transition: "background-color 0.3s ease",
    },
    accordionHeaderHover: {
      backgroundColor: headerHoverBgColor, // Hover background color
    },
    accordionTitle: {
      fontSize: "16px",
    },
    accordionIcon: {
      fontSize: "18px",
    },
    accordionContent: {
      padding: "0", // Adjust padding to add left and right padding
      backgroundColor: headerBgColor, // Content background color
      cursor: "pointer",
    },
    itemFlex: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px 15px", // Adjusted padding for spacing
    },
    itemCount: {
      backgroundColor: itemCountBgColor, // Count background color
      borderRadius: "4px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minWidth: "20px",
      minHeight: "20px",
    },
  };

  return (
    <Box style={styles.accordion}>
      <Box
        style={{
          ...styles.accordionHeader,
          ...(hoverIndex === 0 ? styles.accordionHeaderHover : {}),
        }}
        onClick={() => handleToggle(0)}
        onMouseEnter={() => handleMouseEnter(0)}
        onMouseLeave={handleMouseLeave}
      >
        <Flex
          gap={2}
          fontSize="16px"
          justify={"center"}
          alignItems={"center"}
          py={2}
        >
          <FaInfo />
          <Text mt={"4px"}>Categories</Text>
        </Flex>
        <Box style={styles.accordionIcon}>
          {activeIndex === 0 ? <FaChevronUp /> : <FaChevronDown />}
        </Box>
      </Box>
      <Divider borderColor={dividerColor} />
      {activeIndex === 0 && (
        <Box style={styles.accordionContent}>
          {items.map((item, index) => (
            <React.Fragment key={index}>
              <Box
                style={styles.itemFlex}
                _hover={{ bg: "gray.200" }}
                onClick={() => handleCardClick(item.title)}
              >
                <Box>{item.title}</Box>
                <Box px={2} py={1} style={styles.itemCount}>
                  <Box>{item.count}</Box>
                </Box>
              </Box>
              {index < items.length - 1 && (
                <Divider borderColor={dividerColor} w="100%" />
              )}
            </React.Fragment>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default CustomAccordion;
